/* eslint-disable camelcase */
import { extend } from 'vee-validate';
import { alpha_num } from 'vee-validate/dist/rules';

extend('alpha-num', {
    ...alpha_num,
    message: 'Only letters and numbers are accepted'
});
